export default "<div class=\"multi-selector\">\n</div>\n\n\n"